import _ from 'lodash'
import defaultConfig from './default'
import orderService from 'service/order'
import paymentTypes from 'payment-types'
import cookie from 'cookie'
import {query, append} from 'qs'
import TpUnionLogin from '../service/tpUnionLogin'
import ua from 'ua'
import {shared as progress} from 'progress'
import $ from '$'
import { stringify } from '../qs'

const TPChannelType = 15
const config = {
	flag: 'HYF9562GFFJEJHUYH8KKF93F8B826548',
	code: 9722,
}

const url = ua.isBeta() ?
  'https://172.29.24.138/micrombank/oauth/index.html' :
  'https://mbank.spdbccc.com.cn/micrombank/oauth/index.html'

const userCert = {
  "isBindCard": "40",
  "flag": "HYF9562GFFJEJHUYH8KKF93F8B826548"
}

const transferPage = ua.isBeta() ?
  'https://mbeta.piaoniu.com/order/transfer.html' :
  'https://m.piaoniu.com/order/transfer.html'

module.exports = _.merge({}, defaultConfig, {
	name: '浦发信用卡',
	stripBrand: true,
	showUserEntry: true,
	hideReview: true,
	hideBuyNum: true,
	hideCredit: true,
  isHideTravel: true,
  hideCoupon: true,
	userEntryType: 2,
	match() {
		let userAgent = navigator.userAgent.toLowerCase()
		return /spdb/.test(userAgent)
	},
	pay(subjectId, subjectType, paymentAmount, payReturnPage) {
		// const user = require('user')
		return this.login().then(() => {
			orderService.unifiedPay({
				subjectId,
				subjectType,
				paymentAmount,
				paymentType: paymentTypes.pufabank
			}).then(({paymentParams}) => {
				if (window.jsspdb) {
					window.jsspdb.orderPay(JSON.stringify(paymentParams))
				} else {
					window.webkit.messageHandlers.jsspdb.postMessage(
						{
							"method": "orderPay:",
							"arguments": [JSON.stringify(paymentParams)]
						}
					)
				}
				window.paySuccess = function () {
          TpUnionLogin.getPayDetail(subjectId, subjectType)
            .then((payDetail) => {
              const webRedirectSuccessPage = payDetail && payDetail.payReturnPage.webRedirectSuccessPage
              const webRedirectFailPage = payDetail && payDetail.payReturnPage.webRedirectFailPage
              TpUnionLogin.getTpPaySuccess(subjectId, subjectType)
                .then(res => {
                  if (res.code === 200 && res.success) {
                    location.replace(`${webRedirectSuccessPage}`)
                  } else {
                    location.replace(`${webRedirectFailPage}`)
                  }
                }).catch ((err) => {
                  console.log(err)
                  progress.showMessage(err)
              })
            }).catch (err => {
            progress.showMessage(err)
          })
				}
				window.payError = function () {
					progress.showMessage('出错啦')
				}
			}).catch((err) => {
				// window.pnlogger.sendPageLog('response error:' + err)
			})
		})
	},
  login(redir) {
    return new Promise((resolve, reject) => {
      TpUnionLogin.isLoginState(15)
        .then((isLogin) => {
          if (isLogin && isLogin.tpLogined) {
            resolve()
          } else if (cookie.get('pufaAppLogin')) {
            this.formPost(this.formatRedirectUrl(redir))
          } else {
            const userJson = JSON.stringify(userCert)
            if (window.jsspdb) {
              window.jsspdb.confirmUserInfo(userJson)
            } else {
              window.webkit.messageHandlers.jsspdb.postMessage({
                "method": "confirmUserInfo:",
                "arguments": [userJson]
              });
            }
            window.loginSuccess = function (userInfo) {
              let oauthUrl = ''
              // 前往确认订单页
              if (redir.indexOf('?') !== -1) {
                const params = redir.split('?')[1]
                localStorage.setItem('order_confirm_params', params)
                // const transferPage = 'https://mbeta.piaoniu.com/order/transfer.html'
                oauthUrl = `${url}?userInfo=${encodeURIComponent(userInfo)}&code=${config.code}&url=${transferPage}`
              } else {
              oauthUrl = `${url}?userInfo=${encodeURIComponent(userInfo)}&code=${config.code}&url=${redir}`
              }
              location.replace(oauthUrl)
              cookie.set('pufaAppLogin', 1)
            }
          }
      })
    })
  },

  formPost(redir) {
    return new Promise((resolve) => {
      let url = `https://openuat.spdbccc.com.cn/memoauth/oauthCode.do`
      TpUnionLogin.authCodeRequest(15, {
        redirectUri: redir
      }).then((params) => {
        let form = $("<form method='post' type='hidden'></form>")
        let input
        form.attr({"action": url})
        $.each(params, (key, value) => {
          input = $("<input type='hidden'>")
          input.attr({"name": key})
          input.val(value)
          form.append(input)
        })
        form.appendTo($('body'))
        form.submit()
        $('form')[0].remove()
        cookie.set('pufaAppLogin', null)
        resolve()
      })
    })
	},
	formatRedirectUrl(url) {
    const origin = this.formatOrigin()
		return `${origin}/api/v1/tpUnionLogin/${TPChannelType}/loginThenRedirect?page=${encodeURIComponent(url)}`
	},
	goOrder() {
    const origin = this.formatOrigin()
    if (cookie.get('pufaAppLogin')) {
      this.formPost(this.formatRedirectUrl(`${origin}/user/order.html`))
      return
    }
    this.login(`${origin}/user/order.html`).then(() => {
      window.location.href = `${origin}/user/order.html`
    })
	},
  formatOrigin() {
    // 浦发只允许https链接， 所以讲http转成https
    const origin = location.origin
    if (origin.search('https://') === -1) {
      return `https://${origin}`
    }
    return origin
	}
})



// WEBPACK FOOTER //
// ./src/mods/channels/pufabank.js